export const API_URL = window["apiUrl"];
export const URL_IMG = window["urlImg"];
export const API_CORE_URL = window["apiCoreUrl"];
export const API_CORE_URL_RELATIVE = window["apiCoreUrlRelative"];
export const API_URL_LOCAL= window["apiUrlLocal"];
export const PATH = window["path"];
export const LEGAL_PATROCINADOR_CALIENTE = window["legal_patrocinador_caliente"];
export const LEGAL_PATROCINADOR_CODERE = window["legal_patrocinador_codere"];
export const API_LOCAL = window["apiLocal"];
export const API_PATH_PARTIDOS = window["apiUrlPartidos"];

//_________URL del servicio que deseas consumir_________
export const path = API_URL;
export const apiToday = path + "principales/today.json";
export const pathIframe = window["apiWidgets"];

// Generar URLs de fallback dinámicamente
function generateFallbackUrls(days) {
  const urls = [apiToday];
  
  for (let i = 1; i <= Math.floor(days / 2); i++) {
    urls.unshift(path + `hub_menos_${i}.json`);
  }
  
  for (let i = 1; i <= Math.floor(days / 2); i++) {
    urls.push(path + `hub_mas_${i}.json`);
  }
  
  return urls;
}

// Función para generar endpoints dinámicos basados en fechas UTC
function generateApiEndpoints(baseDate = null) {
  const today = baseDate ? new Date(baseDate) : new Date();
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  
  const getDateOffset = (offset) => {
    const date = new Date(today);
    date.setDate(date.getDate() + offset);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  
  const fallbackUrls = generateFallbackUrls(longitud);
  const halfDays = Math.floor(longitud / 2);
  
  return Array.from({ length: longitud }, (_, index) => {
    const offset = index - halfDays;
    return {
      primary: `${API_CORE_URL}events-by-filters?date=${encodeURIComponent(getDateOffset(offset))}&timezone=${encodeURIComponent(timezone)}`,
      fallback: fallbackUrls[index]
    };
  });
}

export const getApiEndpoints = generateApiEndpoints;
export const longitud = 15; // longitud del arreglo de tabs y servicios
export const initial = Math.ceil(longitud / 2); // posición de HOY en el array
export const apiEndpoints = generateFallbackUrls(longitud);

export const arrayFlags = ["AFG", "ALB", "ALG", "AND", "ANG", "ANT", "ARG", "ARM",
"ARU", "ASA", "AUS", "AUT", "AZE", "BAH", "BAN", "BAR", "BDI", "BEL", "BEN",
"BER", "BHU", "BIH", "BIZ", "BLR", "BOL", "BOT", "BRA", "BRN", "BRU", "BUL",
"BUR", "CAF", "CAM", "CAN", "CAY", "CGO", "CHA", "CHI", "CHN", "CIV", "CMR",
"COD", "COK", "COL", "COM", "CPV", "CRC", "CRO", "CUB", "CYP", "CZE", "DEN",
"DJI", "DMA", "DOM", "ECU", "EGY", "EOR", "ERI", "ESA", "ESP", "EST", "ETH",
"FIJ", "FIN", "FRA", "FSM", "GAB", "GAM", "GBR", "GBS", "GEO", "GEQ", "GER",
"GHA", "GRE", "GRN", "GUA", "GUI", "GUM", "GUY", "HAI", "HKG", "HON", "HUN",
"INA", "IND", "IOA", "IOP", "IRI", "IRL", "IRQ", "ISL", "ISR", "ISV", "ITA",
"IVB", "JAM", "JOR", "JPN", "KAZ", "KEN", "KGZ", "KIR", "KOR", "KOS", "KSA",
"KUW", "LAO", "LAT", "LBA", "LBN", "LBR", "LCA", "LES", "LIE", "LTU", "LUX",
"MAD", "MAR", "MAS", "MAW", "MDA", "MDV", "MEX", "MGL", "MHL", "MKD", "MLI",
"MLT", "MNE", "MON", "MOZ", "MRI", "MTN", "MYA", "NAM", "NCA", "NED", "NEP",
"NGR", "NIG", "NOR", "NRU", "NZL", "OMA", "PAK", "PAN", "PAR", "PER", "PHI",
"PLE", "PLW", "PNG", "POL", "POR", "PRK", "PUR", "QAT", "ROC", "ROU", "RSA",
"RUS", "RWA", "SAM", "SEN", "SEY", "SGP", "SKN", "SLE", "SLO", "SMR", "SOL",
"SOM", "SRB", "SRI", "SSD", "STP", "ZAF", "SUI", "SUR", "SVK", "SWE", "SWZ",
"SYR", "TAN", "TGA", "THA", "TJK", "TKM", "TLS", "TOG", "TPE", "TTO", "TUN",
"TUR", "TUV", "UAE", "UGA", "UKR", "URU", "USA", "UZB", "VAN", "VEN", "VIE",
"VIN", "YEM", "ZAM", "ZIM", "LVA"];